<template>
  <div class="catalog-item-create">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" class="catalog-item-create__modal">

      <md-dialog-content v-if="data">
        <md-button @click="clear()" class="md-icon-button catalog-item-create__button--close">
          <md-icon>close</md-icon>
        </md-button>

        <h3 class="catalog-item-create__title">Kategorie bearbeiten</h3>
        <div class="catalog-item-create__content">

          <form class="md-layout" @submit.prevent="submit">
            <md-field required>
              <label for="name">Bezeichnung</label>
              <md-input name="name" id="name" required v-model="data.name"/>
            </md-field>

            <div class="catalog-item-create__buttons">
              <button type="submit" :disabled="!validated" class="button catalog-item-create__button catalog-item-create__button--add">Speichern</button>
            </div>
          </form>

        </div>
      </md-dialog-content>
    </md-dialog>

  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'CatalogCategoryEdit',
        data() {
            return {
                data: null,
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('catalog', [
                'editCategory'
            ]),
            showDialog: function() {
                return this.editCategory != null
            },
            validated: function() {
                return this.data.name
            }
        },
        mounted() {
            this.prepareData()
        },
        methods: {
            ...mapActions('catalog', [
                'updateCategory',
                'resetCategory'
            ]),
            clear: function() {
                this.resetCategory()
            },
            prepareData: function() {
                this.data = JSON.parse(JSON.stringify(this.editCategory))
                this.data.location_id = this.user.locationId
            },
            submit: function() {
                this.updateCategory(this.data)
            }
        }
    }
</script>